import { ReactElement, useEffect, useState } from 'react'
import { Platform, Pressable, StyleSheet, Switch, SwitchProps, View, ViewStyle } from 'react-native'

import { Color, Spacing } from '../../style'
import { Help } from '../help'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    color: Color.premiumBlack,
  },
  activeText: {
    color: Color.greyBlue,
  },
  label: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  help: {
    flex: 1,
  },
  helpRight: {
    flex: 1,
    alignItems: 'flex-end',
    marginLeft: Spacing.S,
  },
})
export interface Props extends SwitchProps {
  label?: string
  onFocus?: () => void
  onBlur?: () => void
  help?: string | ReactElement
}

const SwitchView = (props: Props) => {
  const { style, label, onFocus, onBlur, help, value: externalValue, onValueChange, ...otherProps } = props
  const [value, setValue] = useState(externalValue)
  const [active, setActive] = useState(false)

  useEffect(() => {
    setValue(externalValue)
  }, [externalValue])

  const updateActive = (value: boolean) => () => {
    setActive(value)
    value && onFocus && onFocus()
    !value && onBlur && onBlur()
  }

  const update = (value: boolean) => {
    onValueChange && onValueChange(value)
    setValue(value)
  }

  const renderLabel = () => {
    const textStyle = [styles.text, active && styles.activeText]
    return <Text style={textStyle}>{label}</Text>
  }

  const switchView = (
    <Switch
      onValueChange={update}
      value={value}
      trackColor={{ false: active ? Color.lightGreyBlue : Color.sleepingGrey, true: Color.lightGreyBlue }}
      thumbColor={!value ? Color.simplyWhite : undefined}
      //@ts-expect-error type
      activeThumbColor={Color.greyBlue}
      style={[
        Platform.select({
          // @ts-expect-error outline style none is not defined
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
        style,
      ]}
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      {...otherProps}
    />
  )
  const switchHelpView = <View style={styles.helpRight}>{switchView}</View>

  const labelView = (
    <Pressable
      onPress={() => update(!value)}
      style={[
        Platform.select({
          // @ts-expect-error outline style none is not defined
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
        styles.label,
      ]}
      hitSlop={40}
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      testID="Switch.Label"
    >
      {renderLabel}
    </Pressable>
  )

  return (
    <View style={styles.container}>
      {label ? (
        help ? (
          <Help message={help} right={switchHelpView} style={styles.help}>
            {labelView}
          </Help>
        ) : (
          <>
            {labelView}
            {switchView}
          </>
        )
      ) : (
        switchView
      )}
    </View>
  )
}

export default SwitchView
